import { useEffect } from "react";
import { useDispatch, useSelector } from "../../../hooks";
import { QuizStatus } from "../../../redux/quizzes";
import { requestQuizQuestion } from "../../../redux/quizzes/request-quiz-question.handler";
import { ContentWrapper } from "../../../components/ContentWrapper/ContentWrapper";
import { IncomeInfo } from "./IncomeInfo/IncomeInfo";
import { QuizExitButton } from "./QuizExitButton/QuizExitButton";
import { QuizQuestionBlock } from "./QuizQuestionBlock/QuizQuestionBlock";
import { QuizResultBlock } from "./QuizResultBlock/QuizResultBlock";
import styles from "./QuizQuestionPage.module.scss";
import { QuizFinishBlock } from "./QuizFinishBlock/QuizFinishBlock";
import { AppContext } from "../../../components/Menu/MenuButton";
import { ActionsContext } from "../../ActionsPage/ACtionsRoutes";
import { useNavigate } from "react-router-dom";

export const QuizQuestionPage = () => {
    const { quiz, isExpired, answerResult } = useSelector(store => store.quiz);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (!quiz)
            return;

        if (quiz.status === QuizStatus.WaitingQuestionRequest) {
            dispatch(requestQuizQuestion());
            return;
        }
    }, [quiz, dispatch]);

    if (!quiz) {
        navigate(`/${AppContext.Actions}/${ActionsContext.Tasks}`, { replace: true });
        return <></>;
    }

    const getBlockContext = () => {
        switch (quiz.status) {
            case QuizStatus.Finished:
            case QuizStatus.WaitingFinishRequest:
            case QuizStatus.Expired:
                return <QuizFinishBlock />;

            case QuizStatus.WaitingAnswer:
                return isExpired || answerResult ? <QuizResultBlock /> : <QuizQuestionBlock />;

            case QuizStatus.WaitingQuestionRequest:
                return <QuizResultBlock />;
        }
    }

    return (
        <ContentWrapper full={ true } context='quiz'>
            <div className={styles.container}>
                <div className={styles.titleBlock}>
                    <h2 className={styles.exitTitle}>Викторина</h2>
                    <QuizExitButton />
                </div>

                <IncomeInfo />
                { getBlockContext() }
            </div>
        </ContentWrapper>
    );
}